import { fetchApi } from "@tiny/utils";
import {
  GetContentDetailsResponse,
  GetSupportedLanguagesResponse,
} from "@/types/api/contentDetails";
import { GetTemplateLayoutOptionsResponse } from "@/types/api/accountTemplateLayouts";
import { defer, LoaderFunctionArgs } from "react-router-dom";

const aiTuningRootLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const { primaryColor, secondaryColor } = Object.fromEntries(url.searchParams);

  const [layoutsDict, accountDetails, languages] = await Promise.all([
    primaryColor && secondaryColor
      ? fetchApi<GetTemplateLayoutOptionsResponse>("/accountservice/layout", {
          signal: request.signal,
          body: JSON.stringify({
            primaryColor,
            secondaryColor,
          }),
          method: "POST",
        })
      : fetchApi<GetTemplateLayoutOptionsResponse>("/accountservice/layout", {
          signal: request.signal,
          method: "GET",
        }),
    fetchApi<GetContentDetailsResponse>(
      "/accountservice/account/content/details",
      { signal: request.signal }
    ),
    fetchApi<GetSupportedLanguagesResponse>(
      "/accountservice/account/content/supported-languages",
      { signal: request.signal }
    ),
  ]);

  const mergedAccountDetails = {
    ...accountDetails,
    languages,
  };

  return defer({ accountDetails: mergedAccountDetails, layoutsDict });
};
export { aiTuningRootLoader };
